import PropTypes from 'prop-types';

import { AssetIcon } from 'src/assets/icons/AssetIcon';
import { IconDocument } from 'src/assets/icons/IconDocument';
import { IconPdf } from 'src/assets/icons/IconPdf';
import { IconPdfBoxed } from 'src/assets/icons/IconPdfBoxed';
import { IconResourceTypeImg } from 'src/assets/icons/ResourceTypeImg';
import { IconResourceTypeImgSmall } from 'src/assets/icons/ResourceTypeImgSmall';
import { IconResourceTypeUrl } from 'src/assets/icons/ResourceTypeUrl';
import { IconResourceTypeUrlSmall } from 'src/assets/icons/ResourceTypeUrlSmall';
import { isResourceFileTypePdf, RESOURCE_CONTENT_TYPE } from 'src/data/performance';

export const ResourceTypeIcon = ({ className, type, fileType, small }) => {
  switch (type) {
    case RESOURCE_CONTENT_TYPE.url:
      return small ? (
        <IconResourceTypeUrlSmall className={className} />
      ) : (
        <IconResourceTypeUrl className={className} />
      );

    case RESOURCE_CONTENT_TYPE.image:
      return small ? (
        <IconResourceTypeImgSmall className={className} />
      ) : (
        <IconResourceTypeImg className={className} />
      );

    case RESOURCE_CONTENT_TYPE.document:
      if (isResourceFileTypePdf(fileType)) {
        return small ? <IconPdf className={className} /> : <IconPdfBoxed className={className} />;
      }
      return <IconDocument className={className} />;

    case RESOURCE_CONTENT_TYPE.messagingBankAsset:
      return <AssetIcon className={className} />;

    default:
      return null;
  }
};

ResourceTypeIcon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  fileType: PropTypes.string,
  small: PropTypes.bool,
};

ResourceTypeIcon.defaultProps = {
  className: null,
  fileType: null,
  small: false,
};
